/* @flow strict */

import * as React from 'react';
import _ from 'lodash';

import './styles.scss';

type PropsType = {
  label?: string | React.Node,
  style?: {},
  styleControll?: {},
  callBack?: (any) => void,
  items: [],
  value?: any,
  validator?: {
    text?: string
  },
  onBlur?: () => void
};

const SimpleSelect = (props: PropsType): React.Element<'div'> => {
  const isShowValMsg = !_.size(props.value) && props.validator;

  return (
    <div className="form-group SimpleInput" style={props.style ? { ...props.style } : {}}>
      {props.label ? <label>{props.label}</label> : null}

      <select
        className={`form-control styled-select ${isShowValMsg ? 'validationElement' : ''}`}
        style={props.styleControll ? { ...props.styleControll } : {}}
        value={props.value}
        onChange={(e: any) => {
          if (props.callBack) {
            props.callBack(e);
          }
        }}
        onBlur={(e: any) => {
          if (props.onBlur) {
            props.onBlur(e);
          }
        }}
      >
        {_.map(props.items, (si: {}, sk: number): React.Element<'options'> => {
          return (
            <option
              key={`SimpleSelect-${sk}`}
              value={si.value}
            >{si.label}</option>
          );
        })}
      </select>
      {props.validator &&
        <div className='vMsg' style={{ display: isShowValMsg ? 'block' : 'none' }}>
          {props.validator.text ?
            <>{props.validator.text}</> :
            <>This field is required.</>
          }
        </div>
      }
    </div>
  );
};

export default SimpleSelect;
